import { Code } from "@/molecules/Code"

import type { AppRegistrationValueProps } from "./AppRegistrationSteps.types"

export const AppRegistrationValue = ({
  label,
  value
}: AppRegistrationValueProps) => (
  <Code.CommandSnippet
    instruction={`${label}: `}
    commands={value}
    copyText={value}
  />
)
